export interface IApiClient {
	request<T = any>(settings: any): Promise<T>;
	head(url: string, settings?: any): Promise<any>;
	get<T = any>(url: string, settings?: any): Promise<T>;
	post<T = any>(url: string, data?: any, settings?: any): Promise<T>;
	put<T = any>(url: string, data?: any, settings?: any): Promise<T>;
	patch<T = any>(url: string, data?: any, settings?: any): Promise<T>;
	delete(url: string, settings?: any): Promise<any>;
}

export default class ApiClient<TClient extends IApiClient> implements IApiClient {
	constructor(private readonly _client: TClient) {
	}

	request<T = any>(settings: any): Promise<T> {
		return this._client.request<T>(settings);
	}

	head(url: string, settings?: any): Promise<any> {
		return this._client.head(url, settings);
	}

	get<T = any>(url: string, settings?: any): Promise<T> {
		return this._client.get<T>(url, settings);
	}

	post<T = any>(url: string, data?: any, settings?: any): Promise<T> {
		return this._client.post<T>(url, data, settings);
	}

	put<T = any>(url: string, data?: any, settings?: any): Promise<T> {
		return this._client.put<T>(url, data, settings);
	}

	patch<T = any>(url: string, data?: any, settings?: any): Promise<T> {
		return this._client.patch<T>(url, data, settings);
	}

	delete(url: string, settings?: any): Promise<any> {
		return this._client.delete(url, settings);
	}
}
